module.exports = __webpack_public_path__ + "img/logosttrvarginha.af9f5511.png";